// Shared motion duration tokens.
// Usage: `transition: \`background-color ${MOTION.FAST} ease\``
export const MOTION = {
  FAST: '150ms',     // hovers, color/bg transitions
  STANDARD: '220ms', // sheet/dropdown open/close
  SLOW: '320ms',     // pill expand, larger reveals
};
